/**
 * @name getPrecision
 *
 * @description Returns the number of signficant decimal places of a given value
 *
 * @example
 * import { getPrecision } from '@workbench/core';
 *
 * getPrecision(1); // 0
 * getPrecision(1.337); // 3
 * getPrecision(1.33700); // 3
 * getPrecision('1.33700'); // 3
 */
export function getPrecision(value: string | number): number {
  return Math.floor(Number(value)) === value ? 0 : String(parseFloat(String(value))).split('.')[1].length || 0;
}
